import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ActualService {
  constants: Constants = new Constants();

  constructor(private readonly http: HttpClient) { }

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*'
    })
  };

  HTTP_CONSTANT_OPTIONS_GET = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
    })
  };

  searchActualData(arrData: any): Observable<any> {
    console.info("Entered searchActualData()");
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post(this.constants.getApiBasePath() + `/maxloadData/getActData/`, arrData, { headers, responseType: 'text' })
      .pipe(
        tap(_ => this.log('Actual Data Search Successfully')),
        catchError(this.handleError<any>('Error'))
      );
  }

  getActualDataPdf(requestData: any): Observable<any> {
    console.info("Entered Actual PDF Search Logic");
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
    .post(
      this.constants.getApiBasePath() + `/maxloadData/getActualPdf/`, 
      requestData, { headers, responseType: 'json' })
    .pipe(
      tap(_ => this.log('Actual View Button PDF Successful')),
      catchError(this.handleError<any>('Actual View Button PDF Generated Error'))
    );
}


  getTruckTypeData(): Observable<any> {
    console.info("Entered Truck Type Logic");

    return this.http
      .get(this.constants.getApiBasePath() + `/maxloadData/truckTypes/`, this.HTTP_CONSTANT_OPTIONS_GET)
      .pipe(
        tap(_ => this.log('Truck Type Data Retrived Successful')),
        catchError(this.handleError<any>('Truck Type Data Retrival Generated Error'))
      );
  }


  getTrailerTypeData(): Observable<any> {
    console.info("Entered Trailer Type Logic");

    return this.http
      .get(this.constants.getApiBasePath() + `/maxloadData/allTrailers/`, this.HTTP_CONSTANT_OPTIONS_GET)
      .pipe(
        tap(_ => this.log('Trailer Type Data Retrived Successful')),
        catchError(this.handleError<any>('Truck Type Data Retrival Generated Error'))
      );
  }

  private handleError<T>(_operation: string, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }
}
